import React from "react";
import { Paths } from "./../constants/UrlConstants";

export default {
  MemInfoTitle: <h2>Membership information</h2>,
  MemInfoDescription: (
    <React.Fragment>
      <p>
        Sign in with MySaga to view and download your policy documentation
        online.
      </p>
      <p>
        You can also use MySaga to view quotes and add a review if you have been
        on a Saga holiday.
      </p>
    </React.Fragment>
  ),
  ButtonText: "MySaga",
  MySagaUrl: "https://www.saga.co.uk/MySaga/Account/",
  HelpSection: {
    HeadingLinkTo: Paths.Help,
    HeadingLinkText: "Help",
    MoreHelpLinkTo: Paths.Help,
    MoreHelpLinkText: "View more help",
    HelpSet: [
      {
        Question: "How do I change my contact details?",
        Answer: (
          <React.Fragment>
            <p>
            To update your address, phone number or to make any other changes,
            please call us on <strong>0800 056 9273</strong> Or call <strong>+44 2082 822946</strong> from abroad.
            </p>
            <p>
              Opening times:
              <br />
              Mon-Fri 8:30am - 7pm
              <br />
              Sat 9am - 1pm
            </p>
          </React.Fragment>
        )
      },
      {
        Question: "How do I make use of my Possibilities membership?",
        Answer: {
          Any: (
            <React.Fragment>
              <p>
                Make the most of life's possibilities through our free
                membership programme with offers and ballots on food, travel,
                events and more – exclusively for Saga customers.
              </p>
              <p>
                Please click the MySaga button above. This will take you to
                MySaga, where you can log in and make use of your Possibilities
                membership.
              </p>
            </React.Fragment>
          )
        }
      },
      {
        Question: "What can I do in MySaga?",
        Answer: (
          <React.Fragment>
            <p>MySaga allows you to:</p>
            <ul>
              <li>Make use of your Possibilities membership</li>
              <li>View Saga quotes</li>
              <li>Access insurance documents</li>
              <li>Manage holiday bookings</li>
              <li>Manage contact preferences</li>
            </ul>
            <p>
              Please click the MySaga button above to make use of these options.
            </p>
          </React.Fragment>
        )
      }
    ]
  }
};
